import * as React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Typography, Box, Container, TextField, CssBaseline, Button, Avatar, Select, MenuItem, InputLabel, FormHelperText, FormControl, CircularProgress, Chip, Tooltip, Autocomplete, Paper, Stack, Divider } from '@mui/material';
import { connect } from "react-redux";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { uploadFile } from '../../core/aws';
import { centered_flex_box, MainInput, MainInputLabel, MainTextArea, main_button, reject_button, sec_button, StyledInput } from '../../app/components/Styles';
import { useNavigate, useParams } from 'react-router-dom';
import ReactFileReader from 'react-file-reader';
import { createEvent, searchEvents } from '../../app/store/actions/eventActions';
import { createPartner } from '../../app/store/actions/adminActions';
import { config } from "../../app/config";
import moment from "moment"
import { Image } from 'antd';

export const CreatePartner = ({ createPartner, searchEvents, events, isLoading }) => {
    window.Buffer = window.Buffer || require("buffer").Buffer;

    const navigate = useNavigate()

    const [image, setImage] = React.useState(null);
    const [accountEvents, setAccountEvents] = React.useState([])

    React.useEffect(() => {
        searchEvents({ page: 1, limit: 100, search: "" })
    }, [])

    const handleAddImage = files => {
        let file = files[0]
        console.log(file)
        setImage(file)
    }

    const handleDeleteImage = () => {
        setImage(null);
    }

    const handleEvents = (event, value) => {
        setAccountEvents(value || [])
    }

    const generatePermissions = () => {
        if (accountEvents.length === 0) {
            return null;
        }

        var items = []

        for (let i = 0; i < accountEvents.length; i++) {
            items.push(
                <Box key={accountEvents[i].id}>
                    <Divider sx={{ my: 2 }} />
                    <Typography fontWeight="bold" sx={{ mb: 2 }}>{accountEvents[i].label}</Typography>
                    {accountEvents[i].byRequest ? (
                        <Stack direction="row" spacing={2} flexWrap="wrap">
                            <FormControlLabel control={<Checkbox name={`acceptRequests-${accountEvents[i].id}`} id={`acceptRequests-${accountEvents[i].id}`} />} label="Can Accept Requests" />
                            <FormControlLabel control={<Checkbox name={`rejectRequests-${accountEvents[i].id}`} id={`rejectRequests-${accountEvents[i].id}`} />} label="Can Reject Requests" />
                            <FormControlLabel control={<Checkbox name={`fulfillRequests-${accountEvents[i].id}`} id={`fulfillRequests-${accountEvents[i].id}`} />} label="Can Verify Requests" />
                        </Stack>
                    ) : (
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            This event does not require request approval. Partner will have full access to view tickets and manage this event.
                        </Typography>
                    )}
                </Box>
            )
        }
        return items
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        try {
            var imageUrl
            if (image) {
                imageUrl = await uploadFile(image)
            }

            const eventsWithPermissions = accountEvents.filter((event) => event.byRequest).map((event) => { return event.id })

            var permissions = {}
            for (const eventId of eventsWithPermissions) {
                permissions[eventId] = {
                    acceptRequests: data.get(`acceptRequests-${eventId}`) === "on",
                    rejectRequests: data.get(`rejectRequests-${eventId}`) === "on",
                    fulfillRequests: data.get(`fulfillRequests-${eventId}`) === "on",
                }
            }

            const creation = {
                image: imageUrl,
                name: data.get("name"),
                email: data.get("email"),
                description: data.get("description"),
                events: accountEvents.map((event) => { return event.id }),
                permissions: permissions
            }

            console.log(creation)
            createPartner(creation, navigate)

        } catch (err) {
            console.log(err)
        }
    };

    if (isLoading) {
        return (
            <Box sx={{ ...centered_flex_box, minHeight: "100vh" }}>
                <CircularProgress sx={{ color: "var(--secColor)" }} />
            </Box>
        )
    }

    return (
        <Container component="main" maxWidth="md">
            <Box sx={{ py: { xs: 3, md: 6 }, px: { xs: 2, md: 3 } }}>
                <Box sx={{ ...centered_flex_box, flexDirection: "column", mb: 3 }}>
                    <Avatar sx={{ bgcolor: "var(--secColor)" }}>
                        <AddCircleOutlineIcon />
                    </Avatar>
                    <Typography fontSize={24} fontWeight="bold" textAlign="center" color={"var(--primaryPurple)"} sx={{ mt: 1 }}>
                        Create Partner Account
                    </Typography>
                </Box>
                <Paper elevation={3} sx={{ p: { xs: 2, sm: 3, md: 4 }, borderRadius: 3 }}>
                    <Box component="form" onSubmit={handleSubmit}>
                        <Stack spacing={2}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'stretch', sm: 'center' }}>
                                <ReactFileReader multipleFiles={false} handleFiles={handleAddImage} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                                    <Button sx={{ ...main_button }} fullWidth={true}><UploadIcon /> Upload Account Image</Button>
                                </ReactFileReader>
                                {image && <Chip label={image.name} onDelete={handleDeleteImage} sx={{ color: "var(--primaryPurple)", bgcolor: "var(--secColor)" }} />}
                            </Stack>

                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <MainInput required fullWidth id="name" label="Partner Name" name="name" />
                                <MainInput fullWidth required type='email' id="email" label="Partner Email" name="email" />
                            </Stack>

                            <MainTextArea fullWidth multiline minRows={5} name="description" label="Partner Description" id="description" />

                            <Divider textAlign="left"><Typography variant="subtitle2" sx={{ color: 'var(--primaryPurple)', fontWeight: 700 }}>Access</Typography></Divider>
                            <Autocomplete
                                disablePortal
                                id="events-combo"
                                options={events ? events.map((event) => { return { label: event.title, id: event._id, byRequest: event.byRequest } }) : []}
                                fullWidth
                                multiple
                                value={accountEvents}
                                onChange={handleEvents}
                                getOptionLabel={(option) => option.label || ''}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip
                                            variant="outlined"
                                            label={option.label}
                                            {...getTagProps({ index })}
                                            key={option.id}
                                            sx={{
                                                color: 'var(--primaryPurple)',
                                                borderColor: 'var(--primaryPurple)',
                                                '& .MuiChip-deleteIcon': {
                                                    color: 'var(--primaryPurple)',
                                                }
                                            }}
                                        />
                                    ))
                                }
                                renderInput={(params) => <MainInput {...params} label="Events Accessible" />}
                            />
                            {generatePermissions()}

                            <Button type="submit" fullWidth variant="contained" sx={{ ...main_button }}>
                                Create
                            </Button>
                        </Stack>
                    </Box>
                </Paper>
            </Box>
        </Container >
    );
}


const mapStateToProps = (state) => ({
    user: state?.auth?.user,
    token: state?.auth?.token,
    isLoading: state?.events?.isLoading,
    events: state?.events?.results?.docs
});

const mapDispatchToProps = { searchEvents, createPartner };

export default connect(mapStateToProps, mapDispatchToProps)(CreatePartner);